<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('apiary_create.title') }}</h1>
      <apiary-form></apiary-form>
    </b-container>
  </div>
</template>

<script>
import ApiaryForm from '../components/ApiaryForm'
export default {
  name: 'ApiaryCreate',
  components: { ApiaryForm }
}
</script>

<style scoped>

</style>
